export default __webpack_public_path__ + "static/media/Tenth.cc0c64e6.png";